/**
 * Created by 1 on 2017/9/12.
 */
/**
 * 标绘的基类
 * @module PlotComponent
 */
'use strict';
define([
    '../utils/CommonUtil',
    '../utils/LayerUtil',
    '../utils/LoggerUtil',
    '../utils/RenderUtil',
    './FreeDrawTool3D/FreeDrawToolPolygon3D',
    './FreeDrawTool3D/FreeDrawToolPolyline3D',
    './PlotOverlayTool3D',
    './PlotTypes',
    './PlotSchema',
    '../base/PureComponent',
    './PlotComponentExt3D',
    '../misc/AppEvents',
    '../g2'
], function (CommonUtil,
    LayerUtil,
    LoggerUtil,
    RenderUtil,
    FreeDrawToolPolygon3D,
    FreeDrawToolPolyline3D,
    PlotOverlayTool3D,
    PlotTypes,
    PlotSchema,
    PureComponent,
    PlotComponentExt3D,
    AppEvents, g2) {
    //标绘类型定义
    var PATTERNS = PlotTypes.PATTERNS;
    //所有标绘枚举
    var TYPES = PlotTypes.TYPES;
    //
    var TYPE_KEYS = PlotTypes.TYPES_KEYS;
    //标绘所属方案的id
    var PLOT_SCHEMA_KEY = '_belong_schema';
    /**
     * 构造方法
     * @constructor
     * @classdesc 标绘组件
     * @augments G.base.PureComponent
     * @alias G.plot.PlotComponent
     * @param {Object} options - 必填，构造参数；
     * @param {G.Map} options.map - 必填，地图对象
     * @param {String} options.layerId - 必填，标绘图层id
     * @param {String} options.symbols -可选，默认的符号
     * @param {String} options.tailedLabelComponent -{G.components.TailedLabelComponent}，可选，引线标注插件
     * @returns {Class} - 实例化的对象
     */
    var component = PureComponent.extend({
        options: {
            /**
             * 默认图层id
             */
            layerId: 'plot-layer',
            /**
             * 默认的符号
             */
            symbols: {
                "text": {
                    "type": "TextSymbol",
                    "options": {
                        "fontFamilyName": "宋体",
                        "fontSize": 12,
                        "foreground": { "a": 255, "r": 0, "g": 0, "b": 255 },
                        "borderColor": { "a": 1, "r": 255, "g": 255, "b": 255 },
                        "borderThickness": 0,
                        "offsetX": 0,
                        "offsetY": 0
                    }
                },
                "point": {
                    "type": "SimpleMarkerSymbol",
                    "options": {
                        "style": "circle",
                        "borderColor": {
                            "a": 153,
                            "r": 0,
                            "g": 0,
                            "b": 0
                        },
                        "fillColor": {
                            "a": 153,
                            "r": 65,
                            "g": 105,
                            "b": 225
                        },
                        "borderThickness": 2,
                        "size": 4
                    }
                },
                "line": {
                    "type": "SimpleLineSymbol",
                    "options": {
                        "color": {
                            "a": 153,
                            "r": 0,
                            "g": 0,
                            "b": 255
                        },
                        "width": 2,
                        "style": 5
                    }
                },
                "polygon": {
                    "type": "SimpleFillSymbol",
                    "options": {
                        "borderColor": {
                            "a": 153,
                            "r": 0,
                            "g": 0,
                            "b": 255
                        },
                        "fillColor": {
                            "a": 150,
                            "r": 19,
                            "g": 181,
                            "b": 177
                        },
                        "borderThickness": 0,
                        "opacity": 1
                    }
                },
                "tailedtext": {
                    "type": "SimpleMarkerSymbol",
                    "options": {
                        "borderColor": {
                            "a": 255,
                            "r": 205,
                            "g": 85,
                            "b": 85
                        },
                        "fillColor": {
                            "a": 255,
                            "r": 205,
                            "g": 85,
                            "b": 85
                        },
                        "borderThickness": 0,
                        "size": 0
                    }
                }
            }
        },
        initialize: function (options) {
            const self = this;
            PureComponent.prototype.initialize.call(this, options);
            //初始化标绘图层
            this._plotLayer = this.getLayer();
            this._tailedLayer = this.getTailedLayer();
            this._highlightLayer = this.getHighlightLayer();
            this._tailedOnMouseUpHandler = function (screenX, screenY, maxX, mapY, event) {
                self._tailedLabelUpdatePlot();
            }
            if (this._tailedLayer) {
                this._tailedLayer.on('mouseup', this._tailedOnMouseUpHandler)
            }
            this._initTools();
            //
            this._currentTool = null;
            //
            this.onMapClick = (a, b, screenX, screenY, mapX, mapY) => {
                this._mapClickHandler(screenX, screenY);
            };
            this.map.on('click', this.onMapClick, this);
            this._freedrawtoolpolygon = new FreeDrawToolPolygon3D();
            this._freedrawtoolpolyline = new FreeDrawToolPolyline3D();
            this._plotOverlayTool = new PlotOverlayTool3D({ map: this.map });
            this._plotOverlayTool.on('overlayClick', this._overlayClick, this);

            // this._addTailedComponent(this.map);
        },
        /**
         * 销毁
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         */
        destroy: function () {
            this.map.off('click', this._mapClickHandler, this);
            // this._tailedLayer.un('mouseup', this._tailedOnMouseUpHandler)
            // TODO 是否需要移除？
            // this.map.removeLayer(this._plotLayer);
            // this.map.removeLayer(this._tailedLayer);
            // this.options.tailedLabelComponent.destroy();
            //
            PureComponent.prototype.destroy.call(this);
        }
    });

    /***
     * 标绘接口
     */
    component.include({
        /**
         * 绘制文字
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param opts {Object} - 必填
         * @param opts.text {String} - 可选，标绘的文本内容
         * @param opts.symbol {Object} - 可选，符号对象
         * @param opts.callback {Function} - 可选，绘制完成的回调，回调参数为当前标绘的元素
         * @param opts.context {Object} - 可选，绘制完成的回调上下文
         * @example
         * var opts={};
         * opts.text='文本';
         * opts.symbol={
         *           "type":"TextSymbol",
         *           "options": {
         *               "fontFamilyName":"宋体",
         *               "fontSize":12,
         *               "offsetX":10,
         *               "offsetY":10,
         *               "foreground": {"a": 255, "r": 0, "g": 0, "b": 255},
         *               "borderColor":{"a": 1, "r": 255, "g": 255, "b": 255},
         *               "borderThickness":0
         *           }
         *       }
         * plotComponent.plotText(opts);
         */
        plotText: function (opts) {
            opts = opts || {};
            var algorithm = this._getAlgorithm(TYPE_KEYS.Point);
            if (algorithm == null) {
                throw (new Error('参数类型错误！'));
            }
            this._plotEditTool.deactivate();
            //
            var g2map = this.map;
            var options = {};
            options.businessId = opts.businessId;
            options.name = opts.name;
            options.pattern = PATTERNS.TEXT;
            options.type = TYPE_KEYS.Point;
            options.algorithm = algorithm;
            options.symbol = opts.symbol;
            options.text = opts.text || '';
            var geometry = new g2.sfs.Point({
                spatialReference: g2map.getSrid()
            });
            options.geometry = geometry;
            options.callback = opts.callback;
            options.context = opts.context;
            var tool = this._constructPlotTool(options);
            //
            tool.onClick();
        },

        /**
         * 绘制引线文本
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param opts {Object} - 必填
         * @param opts.text {String} - 可选，标绘的文本内容
         * @param opts.symbol {Object} - 可选，符号对象
         * @param opts.callback {Function} - 可选，绘制完成的回调，回调参数为当前标绘的元素
         * @param opts.context {Object} - 可选，绘制完成的回调上下文
         *
         */
        plotTailedText: function (opts) {
            opts = opts || {};
            var algorithm = this._getAlgorithm(TYPE_KEYS.TAILEDTEXT);
            if (algorithm == null) {
                throw (new Error('参数类型错误！'));
            }
            this._plotEditTool.deactivate();
            //
            var g2map = this.map;
            var options = {};
            options.businessId = opts.businessId;
            options.name = opts.name;
            options.pattern = PATTERNS.TAILEDTEXT;
            options.type = TYPE_KEYS.Point;
            options.algorithm = algorithm;
            options.symbol = {
                type: 'SimpleMarkerSymbol',
                options: {
                    size: 0,
                }
            };
            options.text = opts.text || '';
            var geometry = new g2.sfs.Point({
                spatialReference: g2map.getSrid()
            });
            options.geometry = geometry;
            options.tailedtext_symbol = opts.tailedtext_symbol;
            options.callback = this.addTailedEle;
            // options.callback=opts.callback;
            options.context = opts.context;
            var tool = this._constructPlotTool(options);
            //
            tool.onClick();
        },
        addTailedEle: function (ele, options, self) {
            let id = ele.id;
            var tailOpts = {};
            //引线指向点
            let point = ele.elements[0].geometry;
            tailOpts.geometry = point;
            tailOpts.label = "自定义文本内容";
            tailOpts.id = id;
            const foregroundColor = options.foregroundColor || { r: 255, b: 255, g: 255, a: 255 };
            const backgroundColor = options.backgroundColor || { r: 205, b: 85, g: 85, a: 255 };
            const textBackgroundBorderColor = options.textBackgroundBorderColor || { r: 220, b: 0, g: 0, a: 255 };
            // const backgroundColor = options.backgroundColor || { r: 205, b: 85, g: 85, a: 255 };
            const lineColor = options.lineColor || { r: 205, b: 85, g: 85, a: 255 };
            const option = {
                id: id,
                dimension: 3,
                anchor: point,
                label: "自定义文本内容",
                fontSize: options.fontSize || 24,
                fontFamilyName: options.fontFamilyName || '宋体',
                foregroundColor: new g2.sfs.Color(foregroundColor),// 字体颜色
                backgroundColor: new g2.sfs.Color(backgroundColor),// 背景颜色 "a": 153,
                textBorderColor: new g2.sfs.Color(foregroundColor),
                textBorderThickness: 0,
                textBackgroundBorderColor: new g2.sfs.Color(textBackgroundBorderColor),
                textBackgroundBorderThickness: options.textBackgroundBorderThickness || 2,
                leadLength: options.leadLength || 100,
                angle: options.angle || 45,
                lineColor: new g2.sfs.Color(lineColor),
                lineWidth: options.lineWidth || 1,
                size: options.size || 6,
                textAlign: options.textAlign || 'center',
                padding: options.padding || [10, 10, 10, 10]
            }
            const leadLabel = new g2.sfs.LeadLabel(option);
            leadLabel.tag = {tooId: ele.tag.toolId, businessId: ele.tag.businessId, name: ele.tag.name};
            self._tailedLayer.add(leadLabel);
            self._tailedLabelUpdatePlot();
            // 开启拖拽事件
            setTimeout(() => {
                self.dragTailedText();
            }, 500);
        },
        dragTailedText: function () {
            this.map.currentTool(this._tailedEditTool);
            // this._currentTool = this._tailedEditTool;
            // this._commandNotify.activeCommand('leadLabelEditTool3D');
        },
        /*  addTailedEle: function (opts, self) {
         
         let layer = self.options.tailedLabelComponent.getLayer();
         let id = opts.id;
         var tailOpts = {};
         //引线指向点
         let point = {
         type: 'Point',
         coordinates: [opts.elements[0].geometry.x, opts.elements[0].geometry.y]
         };
         tailOpts.geometry = point;
         tailOpts.label = "自定义文本内容";
         tailOpts.id = id;
         let tailedLabelId = self.options.tailedLabelComponent.add(tailOpts);
         console.log(opts);
         let tailedLabel = self.options.tailedLabelComponent._getTailedLabel(id);
         opts.tailedLabelAttr = tailedLabel.serialize();
         tailedLabel.on('updateTailedLabelAttr', function () {
         let id = this._id;
         self.getPlotElementById(id).tailedLabelAttr = this.serialize();
         })
         tailedLabel.on('tailedLabelClick', function () {
         let id = this._id;
         self.fire('openTailedLabelEdit', self.getPlotElementById(id))
         })
         }, */
        /**
         * 标绘点
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param opts {Object} - 必填
         * @param opts.symbol {Object} - 可选，符号对象
         * @param opts.callback {Function} - 可选，绘制完成的回调，回调参数为当前标绘的元素
         * @param opts.context {Object} - 可选，绘制完成的回调上下文
         * @example
         *    var opts={};
         *    opts.symbol={
         *           type:'PictureMarkerSymbol',
         *           options:{
         *               "source":'图片base64码',
         *               "width": 50,
         *               "height": 50,
         *               "offsetX": "15",
         *               "offsetY": "45",
         *               "opacity": "1"
         *           }
         *      };
         * plotComponent.plotMarker(opts);
         */
        plotMarker: function (opts) {
            if (opts.type === 'Overlay') {
                opts = opts || {};
                var algorithm = this._getAlgorithm(TYPE_KEYS.Overlay);
                if (algorithm == null) {
                    throw (new Error('参数类型错误！'));
                }
                this._plotEditTool.deactivate();
                //
                var g2map = this.map;
                var options = {};
                options.businessId = opts.businessId;
                options.name = opts.name;
                options.pattern = PATTERNS.OVERLAY;
                options.type = TYPE_KEYS.Point;
                options.algorithm = algorithm;
                options.symbol = {
                    type: 'SimpleMarkerSymbol',
                    options: {
                        size: 0,
                    }
                };;
                options.overlayOpt = opts.overlayOpt;
                var geometry = new g2.sfs.Point({
                    spatialReference: g2map.getSrid()
                });
                options.geometry = geometry;
                options.callback = this.addOverlay;
                options.context = opts.context;
                var tool = this._constructPlotTool(options);
                //
                tool.onClick();
            } else {
                opts = opts || {};
                var algorithm = this._getAlgorithm(TYPE_KEYS.Point);
                if (algorithm == null) {
                    throw (new Error('参数类型错误！'));
                }
                this._plotEditTool.deactivate();
                //
                var g2map = this.map;
                var options = {};
                options.businessId = opts.businessId;
                options.name = opts.name;
                options.pattern = PATTERNS.POINT;
                options.type = TYPE_KEYS.Point;
                options.algorithm = algorithm;
                options.symbol = opts.symbol;
                var geometry = new g2.sfs.Point({
                    spatialReference: g2map.getSrid()
                });
                options.geometry = geometry;
                options.callback = opts.callback;
                options.context = opts.context;
                var tool = this._constructPlotTool(options);
                //
                tool.onClick();
            }
        },
        addOverlay: function (ele, options, self) {
            let id = ele.id;
            //引线指向点
            let point = ele.elements[0].geometry;
            const opt = {
                id,
                point,
                options,
                tag: {
                    toolId: ele.tag.toolId,
                    name: ele.tag.name,
                    businessId: ele.tag.businessId,
                },
            };
            self._plotOverlayTool.add(opt);
        },
        /**
         * 标绘线
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param opts {Object} - 必填
         * @param opts.type {String} - 必填，标绘的类型，G.plot.TYPES下的枚举值;
         * @param opts.symbol {Object} - 可选，符号对象
         * @param opts.callback {Function} - 可选，绘制完成的回调，回调参数为当前标绘的元素
         * @param opts.context {Object} - 可选，绘制完成的回调上下文
         * @example
         *    var opts={};
         *    opts.type=G.plot.TYPES.Polyline;
         *    opts.symbol={
         *           "type": "SimpleFillSymbol",
         *           "options": {
         *               "borderColor":{
         *                   "a": 153, "r": 0, "g": 0, "b": 255
         *               },
         *               "fillColor":{
         *                   "a": 255, "r": 0, "g": 0, "b": 177
         *               },
         *               "borderThickness": 0,
         *               "opacity":1
         *           }
         *       }
         * plotComponent.plotPolyline(opts);
         */
        plotPolyline: function (opts) {
            opts = opts || {};
            // 优先使用tsgis 的自有标绘算法
            if (opts.type == TYPE_KEYS.FreePolyline && !(g2.plot.FreePolylineAlgorithm)) {
                var options = {};
                options.businessId = opts.businessId;
                options.name = opts.name;
                options.name = opts.name;
                options.symbol = opts.symbol;
                options.callback = opts.callback;
                this.plotFreeDrawPolyline(options);
            } else {
                var options = {};
                options.map = this.map;
                options.size = opts.size;
                var algorithm = this._getAlgorithm(opts.type || TYPE_KEYS.Polyline, options);
                if (algorithm == null) {
                    throw (new Error('参数类型错误！'));
                }
                this._plotEditTool.deactivate();
                //
                var g2map = this.map;
                var options = {};
                options.businessId = opts.businessId;
                options.name = opts.name;
                options.pattern = PATTERNS.POLYLINE;
                options.type = opts.type || TYPE_KEYS.Polyline;
                options.algorithm = algorithm;
                options.symbol = opts.symbol;
                var path = new g2.sfs.Path({ spatialReference: g2map.getSrid() });
                path.addPoint(new g2.sfs.Point({ spatialReference: g2map.getSrid() }));
                path.addPoint(new g2.sfs.Point({ spatialReference: g2map.getSrid() }));
                var geometry = new g2.sfs.Polyline({ spatialReference: g2map.getSrid() });
                geometry.addGeometry(path);
                options.geometry = geometry;
                options.callback = opts.callback;
                options.context = opts.context;
                var tool = this._constructPlotTool(options);
                //
                tool.onClick();
            }
        },
        /**
         * 标绘面
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param opts {Object} - 必填
         * @param opts.type {String} - 必填，标绘的类型，G.plot.TYPES下的枚举值;
         * @param opts.symbol {Object} - 可选，符号对象
         * @param opts.callback {Function} - 可选，绘制完成的回调，回调参数为当前标绘的元素
         * @param opts.context {Object} - 可选，绘制完成的回调上下文
         * @example
         *    var opts={};
         *    opts.type=G.plot.TYPES.Polygon;
         *    opts.symbol={
         *           "type": "SimpleFillSymbol",
         *           "options": {
         *               "borderColor":{
         *                   "a": 153, "r": 0, "g": 0, "b": 255
         *               },
         *               "fillColor":{
         *                   "a": 255, "r": 0, "g": 0, "b": 177
         *               },
         *               "borderThickness": 0,
         *               "opacity":1
         *           }
         *       }
         * plotComponent.plotPolygon(opts);
         */
        plotPolygon: function (opts) {
            opts = opts || {};
            // 优先使用tsgis 的自有标绘算法
            if (opts.type == TYPE_KEYS.FreePolygon && !(g2.plot.FreePolygonAlgorithm)) {
                var options = {};
                options.businessId = opts.businessId;
                options.name = opts.name;
                options.map = this.map;
                options.drawLayer = this._plotLayer;
                options.pattern = PATTERNS.POLYGON;
                options.appevent = AppEvents.PLOT_CREATED;
                options.type = TYPE_KEYS.Polygon;
                options.symbol = opts.symbol;
                options.callback = opts.callback;
                options.context = this;
                this.plotFreeDrawPolygon(options);
            } else {
                var options = {};
                options.map = this.map;
                options.size = opts.size;
                var algorithm = this._getAlgorithm(opts.type || TYPE_KEYS.Polygon, options);
                if (algorithm == null) {
                    throw (new Error('参数类型错误！'));
                }
                this._plotEditTool.deactivate();
                //
                var g2map = this.map;
                var options = {};
                options.businessId = opts.businessId;
                options.name = opts.name;
                options.pattern = PATTERNS.POLYGON;
                options.type = opts.type || TYPE_KEYS.Polygon;
                options.algorithm = algorithm;
                options.symbol = opts.symbol;
                // 创建一个空的Polygon对象
                var polygon = new g2.sfs.Polygon({
                    spatialReference: g2map.getSrid()
                });
                //创建一个ring对象
                var ring = new g2.sfs.Ring({
                    spatialReference: g2map.getSrid()
                });
                ring.addPoint(new g2.sfs.Point());
                ring.addPoint(new g2.sfs.Point());
                ring.addPoint(new g2.sfs.Point());
                ring.addPoint(new g2.sfs.Point());
                polygon.addGeometry(ring);
                options.geometry = polygon;
                options.callback = opts.callback;
                options.context = opts.context;
                var tool = this._constructPlotTool(options);
                //
                tool.onClick();
            }
        },
        /**
         * 标绘复合符号
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param opts {Object} - 必填
         * @param opts.type {String} - 必填，标绘的类型，G.plot.TYPES下的枚举值;
         * @param opts.symbol {Object} - 可选，符号对象或者符号数组
         * @param opts.callback {Function} - 可选，绘制完成的回调，回调参数为当前标绘的元素
         * @param opts.context {Object} - 可选，绘制完成的回调上下文
         * @example
         *    var opts={};
         *    opts.type=G.plot.TYPES.DoubleArrow;
         *    opts.symbol={
         *           "type": "SimpleFillSymbol",
         *           "options": {
         *               "borderColor":{
         *                   "a": 153, "r": 0, "g": 0, "b": 255
         *               },
         *               "fillColor":{
         *                   "a": 255, "r": 0, "g": 0, "b": 177
         *               },
         *               "borderThickness": 0,
         *               "opacity":1
         *           }
         *       }
         * plotComponent.plotComposite(opts);
         */
        plotComposite: function (opts) {
            opts = opts || {};
            var options = {};
            options.map = this.map;
            options.size = opts.size;
            var algorithm = this._getAlgorithm(opts.type, options);
            if (algorithm == null) {
                throw (new Error('参数类型错误！'));
            }
            this._plotEditTool.deactivate();
            //
            var g2map = this.map;
            var options = {};
            options.businessId = opts.businessId;
            options.name = opts.name;
            options.pattern = PATTERNS.COMPOSITE;
            options.type = PATTERNS.POLYGON;
            options._type = opts.type;
            options.algorithm = algorithm;
            if (CommonUtil.isArray(opts.symbol)) {
                options.symbol = opts.symbol;
            } else if (CommonUtil.isObject(opts.symbol)) {
                options.symbol = [opts.symbol, opts.symbol];
            }
            // 创建一个空的Polygon对象
            var polygon = new g2.sfs.Polygon({
                spatialReference: g2map.getSrid()
            });
            //创建一个ring对象
            var ring = new g2.sfs.Ring({
                spatialReference: g2.sfs.EnumSpatialReference.EPSG4326
            });
            ring.addPoint(new g2.sfs.Point());
            ring.addPoint(new g2.sfs.Point());
            ring.addPoint(new g2.sfs.Point());
            ring.addPoint(new g2.sfs.Point());
            polygon.addGeometry(ring);
            var path = new g2.sfs.Path({ spatialReference: g2map.getSrid() });
            path.addPoint(new g2.sfs.Point());
            path.addPoint(new g2.sfs.Point());
            var polyline = new g2.sfs.Polyline({ spatialReference: g2map.getSrid() });
            polyline.addGeometry(path);
            options.geometry = [polygon, polyline];
            options.callback = opts.callback;
            options.context = opts.context;
            var tool = this._constructPlotTool(options);
            //
            tool.onClick();
        },
        /**
         * 自由绘制线方法
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param opts {Object} - 必填
         * @param opts.callback {Function} - 可选，绘制完成的回调，回调参数为当前标绘的元素;
         * @param opts.context {Object} - 必填，绘制完成的上下文;
         */
        plotFreeDrawPolyline: function (opts) {
            var map = this.map;
            var drawLayer = this._plotLayer;
            var callback = opts.callback;
            var symbol = opts.symbol || this.options.symbols.line;
            var pattern = PATTERNS.POLYLINE;
            var type = TYPE_KEYS.Polyline;
            var appevent = AppEvents.PLOT_CREATED;
            var context = this;
            var contextx = opts.context;
            let srid = map.getSrid();
            // 构建一个空的polyline对象
            var path = new g2.sfs.Path({ spatialReference: srid });
            path.addPoint(new g2.sfs.Point({ spatialReference: srid }));
            path.addPoint(new g2.sfs.Point({ spatialReference: srid }));
            var polyline = new g2.sfs.Polyline({ spatialReference: srid });
            polyline.addGeometry(path);
            // 创建要标绘的元素所参照的模板
            var templateElement = new g2.sfs.Element({
                geometry: polyline, //空间几何对象
                symbol: this._getDefaultSymbol(pattern, symbol) //简单填充类型符号
            });
            //标绘命令构造器
            this._freedrawtoolpolyline.onCreate({
                map: map,
                spatialRef: map.getSrid(),
                callBack: callback,
                drawLayer: drawLayer,
                templateElement: templateElement,
                lineSymbol: symbol,
                pattern: pattern,
                type: type,
                appevent: appevent,
                context: context,
                contextx: contextx
            }); //传入地图实例和空间坐标参考
            this._currentTool = this._freedrawtoolpolyline;
            this._freedrawtoolpolyline.onClick();
        },
        /**
         * 自由绘制面方法
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param opts {Object} - 必填
         * @param opts.symbol {Object} - 可选，符号对象;
         * @param opts.callback {Function} - 可选，绘制完成的回调，回调参数为当前标绘的元素;
         * @param opts.context {Object} - 必填，绘制完成的上下文;
         */
        plotFreeDrawPolygon: function (opts) {
            var map = this.map;
            var drawLayer = this._plotLayer;
            var callback = opts.callback;
            var symbol = opts.symbol || this.options.symbols.polygon;
            var pattern = PATTERNS.POLYGON;
            var type = TYPE_KEYS.Polygon;
            var appevent = AppEvents.PLOT_CREATED;
            var context = this;
            var contextx = opts.context;
            let srid = map.getSrid();
            // 构建一个空的polyline对象
            var path = new g2.sfs.Path({ spatialReference: srid });
            path.addPoint(new g2.sfs.Point({ spatialReference: srid }));
            path.addPoint(new g2.sfs.Point({ spatialReference: srid }));
            var polyline = new g2.sfs.Polyline({ spatialReference: srid });
            polyline.addGeometry(path);
            // 创建要标绘的元素所参照的模板
            var templateElement = new g2.sfs.Element({
                geometry: polyline, //空间几何对象
                symbol: this._getDefaultSymbol(pattern, symbol)
            });
            //标绘命令构造器
            this._freedrawtoolpolygon.onCreate({
                map: map,
                spatialRef: map.getSrid(),
                callBack: callback,
                drawLayer: drawLayer,
                templateElement: templateElement,
                fillSymbol: symbol,
                pattern: pattern,
                type: type,
                appevent: appevent,
                context: context,
                contextx: contextx
            }); //传入地图实例和空间坐标参考
            this._currentTool = this._freedrawtoolpolygon;
            this._freedrawtoolpolygon.onClick();
        },
        /**
         * 标绘接口，支持所有类型（文本、点、线、面、复合符号）
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param opts {Object} - 必填
         * @param opts.type {String} - 必填，标绘的类型，G.plot.TYPES下的枚举值;
         * @param opts.symbol {Object} - 可选，符号对象
         * @param opts.callback {Function} - 可选，绘制完成的回调，回调参数为当前标绘的元素
         * @param opts.context {Object} - 可选，绘制完成的回调上下文
         */
        plot: function (opts) {
            var fns = {};
            fns[PATTERNS.TEXT] = this.plotText;
            fns[PATTERNS.TAILEDTEXT] = this.plotTailedText;
            fns[PATTERNS.POINT] = this.plotMarker;
            fns[PATTERNS.POLYLINE] = this.plotPolyline;
            fns[PATTERNS.POLYGON] = this.plotPolygon;
            fns[PATTERNS.COMPOSITE] = this.plotComposite;
            // fns[PATTERNS.OVERLAY] = this.plotOverlay;
            //
            opts = opts || {};
            var algorithm = this._getAlgorithm(opts.type);
            if (algorithm == null) {
                throw (new Error('参数类型错误！'));
            }
            var fn = fns[algorithm._type];
            if (CommonUtil.isFunction(fn)) {
                var optss = jQuery.extend(true, {}, opts);
                fn.call(this, optss);
            }
        }
    });
    /***
     * 标绘管理接口
     */
    component.include({
        /**
         * 监听标绘点击事件，标绘图层点击时触发，如果点击了标绘元素，回调参数为该标绘元素，否则回调参数为null
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @deprecated
         * @param callback {Function} - 必填，监听的回调
         * @param context {Object} - 可选，回调上下文
         */
        onPlotClick: function (callback, context) {
            this._plotClickObj = {
                callback: callback,
                context: context
            }
        },
        /**
         * 获取标绘图层
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @returns {Object} - g2.lys.Layer|*
         */
        getLayer: function () {
            if (!this._plotLayer) {
                var layerId = this.options.layerId,
                    g2map = this.map,
                    layer = LayerUtil.getLayerById(this.map, layerId);
                if (!layer) {
                    layer = new g2.carto.CanvasLayer3D({
                        map: g2map,
                        id: layerId,
                        zIndex: 20,
                    });
                    g2map.addLayer(layer);
                }
                this._plotLayer = layer;
            }
            return this._plotLayer;
        },
        /**
         * 获取引线标注图层
         */
        getTailedLayer: function () {
            if (!this._tailedLayer) {
                var layerId = this.options.layerId + '_tailed',
                    g2map = this.map,
                    layer = LayerUtil.getLayerById(this.map, layerId);
                if (!layer) {
                    layer = new g2.carto.LeadLabelLayer3D({
                        map: g2map,
                        id: layerId
                    });
                    g2map.addLayer(layer);
                }
                this._tailedLayer = layer;
            }
            return this._tailedLayer;
        },
        /**
         * 获取高亮图层
         */
        getHighlightLayer: function () {
            if (!this._highlightLayer) {
                var layerId = this.options.layerId + '_highlight',
                    g2map = this.map,
                    layer = LayerUtil.getLayerById(this.map, layerId);
                const zIndex = this._plotLayer.getZIndex();
                if (!layer) {
                    layer = new g2.carto.ElementLayer3D({
                        map: g2map,
                        id: layerId,
                        zIndex: zIndex + 10,
                    });
                    g2map.addLayer(layer);
                }
                this._highlightLayer = layer;
            }
            return this._highlightLayer;
        },
        /**
         * 增加指定id对应标绘的高亮
         * @param {*} id
         */
        addHighlight: function (id) {
            let element = this.getPlotElementById(id);
            if (element) {
                const kind = element.kind;
                if (kind !== 'overlay') {
                    if (kind === 'tailedtext') {
                        const leadLabel = this.getTailedLabelbyId(id);
                        element = this._tailedLayer.leadLabelHash.get(leadLabel);
                        this.highlight = {
                            element,
                            layer: this._tailedLayer,
                        };
                    } else {
                        this.highlight = {
                            element,
                            layer: this._plotLayer,
                        };
                    }
                    this.layerShowElemenet(false);
                    for (let i = 0; i < element.elements.length; i++) {
                        const ele = element.elements[i];
                        const copy = ele.copy();
                        const symbol = copy.symbol;
                        if (symbol.borderThickness || symbol.borderThickness === 0) {
                            symbol.borderThickness = parseInt(symbol.borderThickness) + 5;
                        }
                        if (symbol.width || symbol.width === 0) {
                            symbol.width = parseInt(symbol.width) + 5;
                        }
                        if (symbol.source) {
                            symbol.scale = parseInt(symbol.scale) * 1.5;
                        }
                        if (symbol.fontSize) {
                            if (symbol.fontWeight) {
                                symbol.fontWeight = symbol.fontWeight * 1.2;
                            } else {
                                symbol.fontWeight = 100;
                            }
                            if (kind !== 'tailedtext') {
                                symbol.borderColor.a = 255;
                                if (symbol.borderThickness || symbol.borderThickness === 0) {
                                    symbol.borderThickness = parseInt(symbol.borderThickness) + 5;
                                } else {
                                    symbol.borderThickness = 5;
                                }
                                symbol.fontSize = symbol.fontSize * 1.2;
                            } else {
                                symbol.borderThickness = ele.symbol.borderThickness;
                            }
                        }
                        const highlightEle = new g2.sfs.Element({
                            geometry: ele.geometry,
                            symbol: symbol
                        });
                        highlightEle._plotId = id;
                        this._highlightLayer.add(highlightEle);
                    }
                }
            }
          
            
        },
        /**
         * 移除指定id对应标绘的高亮
         * @param {*} id
         */
        removeHighlight: function (id) {
            this.layerShowElemenet(true);
            for (let i = this._highlightLayer._elements.length - 1; i >= 0; i--) {
                const element = this._highlightLayer._elements[i];
                if (element._plotId === id) {
                    this._highlightLayer.remove(element);
                }
            }
        },
        layerShowElemenet: function (flag) {
            if (this.highlight && this.highlight.layer && this.highlight.element) {
                this.highlight.layer.showElement(this.highlight.element, flag);
            }
        },
        /**
         * 清除全部高亮
         */
        clearHighlights: function () {
            this._highlightLayer.clear();
        },
        /**
         * 获取所有标绘
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @returns {Array}
         */
        getPlotElements: function () {
            return this._plotLayer.elements;
        },

        /**
         * 根据id获取标绘元素
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param id {String} - 必填，元素id
         * @returns {Object} - g2.sfs.PlotElement
         */
        getPlotElementById: function (id) {
            return this._plotLayer.find(id) || null;
        },

        /**
         * 取消标绘
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         */
        cancelPlot: function () {
            this._cancelPlot();
            //派发事件
            this._fireEvent(AppEvents.PLOT_CANCELED);
        },
        /**
         * 切换坐标编辑
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param enabled {boolean} 必填，true开启，false关闭
         */
        enableEdit: function (enabled) {
            if (enabled === true) {
                this._plotEditTool._enabled_ = true;
                this._resetToolState();
            } else {
                this._plotEditTool._enabled_ = false;
                this._resetToolState();
            }
        },
        /**
         * 完成标绘
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         */
        finishPlot: function () {
            if (this._currentTool == null ||
                this._currentTool.isEndDraw == true ||
                this._lastControlPoint == null) {
                throw (new Error('当前无未完成的标绘！'));
            } else {
                this._currentTool.endDraw(this._lastControlPoint);
            }
        },
        /**
         * 获取当前编辑的标绘
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @returns {Array}
         */
        getSelectedElements: function () {
            var selSet = this._plotEditTool.selectionSet;
            return selSet.graphiclist;
        },
        /**
         * 选中元素，进入编辑状态
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param id {String} - 必填，元素id
         */
        selectPlotElement: function (id) {
            var plotElement = this.getPlotElementById(id);
            if (plotElement) {
                try {
                    var geom = plotElement.elements[0].geometry,
                        wkt = geom.asWkt(),
                        regex = /[^\d^\.^\,^\ ]/g,
                        str = wkt.replace(regex, ''),
                        g2map = this.map;
                    var arr = str.split(',')[0].split(' ');
                    var x = parseFloat(arr[0]),
                        y = parseFloat(arr[1]);
                    var screenPt = g2map.getPixelFromCoordinate([x, y]);
                    this._plotEditTool.onMouseDown(null, null, screenPt[0], screenPt[1]);
                } catch (e) {
                    throw (new Error(e));
                }
            } else {
                LoggerUtil.warn('标绘元素不存在！');
            }
        },
        /**
         * 更新标绘
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param opts {Object} - 必填
         * @param opts.id {String} - 必填，编辑的标绘元素id
         * @param opts.symbol {Object}　- 必填，符号样式
         * @returns {Boolean}
         * @example
         * var options={
         *       "id": "abcde",//元素id
         *       "symbol": {
         *          "type": "SimpleFillSymbol",
         *          "options": {
         *              "borderColor": {
         *                  "a": 153,
         *                  "r": 0,
         *                  "g": 0,
         *                  "b": 255
         *              },
         *              "fillColor": {
         *                  "a": 150,
         *                  "r": 19,
         *                  "g": 181,
         *                  "b": 177
         *              },
         *              "borderThickness": 2,
         *              "opacity": 1
         *           }
         *       }
         *   }
         *  plotComponent.updatePlotElement(options);
         *
         */
        updatePlotElement: function (opts) {
            opts = opts || {};
            var objArr = [];
            var obj = null;
            var plotElement = this._plotLayer.find(opts.id);
            if (plotElement) {
                if (plotElement.kind == 'composite') {
                    var elementL = plotElement.elements[1];
                    var elementP = plotElement.elements[0];
                    var symbolObj = opts.symbol;
                    var attArr = opts.plotProperty;
                    obj = new g2.sfs.Attribute({
                        name: 'data',
                        value: attArr
                    });
                    objArr.push(obj);
                    elementP.attributeSet.attributes = objArr;
                    if (CommonUtil.isObject(symbolObj)) {
                        var symbol = RenderUtil.object2Symbol(symbolObj.type, symbolObj.options);
                        elementP.symbol = symbol;
                        elementL.symbol.color = symbol.borderColor;
                        elementL.symbol.width = symbol.borderThickness;
                        this._plotLayer.update(plotElement, true);
                        //派发更新事件
                        this._fireEvent(AppEvents.PLOT_UPDATED, {
                            element: plotElement //标绘元素
                        });
                        return true;
                    }
                    return false;
                } else if (plotElement.kind == 'tailedtext') {
                    var element = plotElement.elements[plotElement.elements.length - 1];
                    var symbolObj = opts.symbol;
                    // var attArr = opts.plotProperty;
                    obj = new g2.sfs.Attribute({
                        name: 'data',
                        value: attArr
                    });
                    objArr.push(obj);
                    element.attributeSet.attributes = objArr;
                    if (CommonUtil.isObject(symbolObj)) {
                        // var symbol = RenderUtil.object2Symbol(symbolObj.type, symbolObj.options);
                        // element.symbol = symbol;
                        // this._plotLayer.update(plotElement, true);

                        var options = opts.symbol.options;
                        let id = plotElement.id;
                        let leadLabel = this._getTailedLabelById(id);
                        let opacity = options.opacity
                        leadLabel.label = options.label;
                        leadLabel.fontSize = options.fontSize;
                        leadLabel.fontFamilyName = options.fontFamilyName;
                        leadLabel.foregroundColor = options.foregroundColor;// 字体颜色
                        leadLabel.foregroundColor.a = opacity;
                        leadLabel.backgroundColor = options.backgroundColor;// 背景颜色
                        leadLabel.backgroundColor.a = opacity;
                        leadLabel.lineColor = options.lineColor;
                        leadLabel.lineColor.a = opacity;
                        leadLabel.lineWidth = options.lineWidth;
                        leadLabel.textBackgroundBorderColor = options.textBackgroundBorderColor;
                        leadLabel.textBackgroundBorderColor.a = opacity;
                        leadLabel.textBackgroundBorderThickness = options.textBackgroundBorderThickness;
                        leadLabel.textBorderColor = options.foregroundColor; // border和字体颜色一致
                        // leadLabel.textBorderThickness = options.textBorderThickness;
                        this._tailedLayer.update(leadLabel);
                        this._tailedLabelUpdatePlot();
                        /*    this.options.tailedLabelComponent.update(opts.id, domOptions.domHtml, domOptions)
                         var tailedLabel = this.options.tailedLabelComponent._getTailedLabel(opts.id);
                         plotElement.tailedLabelAttr = tailedLabel.serialize();
                         */
                        //派发更新事件
                        this._fireEvent(AppEvents.PLOT_UPDATED, {
                            element: plotElement //标绘元素
                        });
                        return true;
                    }
                    return false;
                } else {
                    var element = plotElement.elements[plotElement.elements.length - 1];
                    var symbolObj = opts.symbol;
                    var attArr = opts.plotProperty;
                    obj = new g2.sfs.Attribute({
                        name: 'data',
                        value: attArr
                    });
                    objArr.push(obj);
                    element.attributeSet.attributes = objArr;
                    if (CommonUtil.isObject(symbolObj)) {
                        var symbol = RenderUtil.object2Symbol(symbolObj.type, symbolObj.options);
                        element.symbol = symbol;
                        this._plotLayer.update(plotElement, true);
                        //派发更新事件
                        this._fireEvent(AppEvents.PLOT_UPDATED, {
                            element: plotElement //标绘元素
                        });
                        return true;
                    }
                    return false;
                }
            } else {
                LoggerUtil.warn('元素不存在，id=' + opts.id);
            }
        },
        /**
         * 根据 businessId 删除 标绘图形
         */
        removeByBusinessId: function (businessId) {
            const elements = this._plotLayer.elements;
            for (let i = elements.length -1; i >= 0; i--) {
                const ele = elements[i];
                const ele_businessId = ele.tag.businessId;
                if (ele_businessId && ele_businessId === businessId) {
                    this._removePlotElement(ele.id);
                    this._removeTailedTextById(ele.id);
                    this._removeOverlayById(ele.id);
                } 
            }
        },
        /**
         * 移除标绘
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param id {String} - 必填，移除的元素id
         * @returns {Object} - 删除的元素,g2.sfs.PlotElement
         */
        removePlotElement: function (id) {
            var plotElement = this._removePlotElement(id);
            this._removeTailedTextById(id);
            this._removeOverlayById(id);
            if (plotElement != null) {
                //派发删除事件
                this._fireEvent(AppEvents.PLOT_DELETE, {
                    elements: [plotElement]
                });
            }
            return plotElement;
        },
        /**
         * 移除标绘
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param ids {String} - 必填，移除的元素id,逗号分隔
         * @returns {Array} 删除的元素
         */
        removePlotElements: function (ids) {
            ids = ids || '';
            var arr = ids.split(',');
            var plotElements = [];
            for (var i = 0, len = arr.length; i < len; i++) {
                var id = arr[i];
                var plotElement = this.removePlotElement(id);
                if (plotElement != null) {
                    plotElements.push(plotElement);
                }
            }
            //派发删除事件
            this._fireEvent(AppEvents.PLOT_DELETE, {
                elements: plotElements
            });
            return plotElements;
        },
        /**
         * 清除所有标绘
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @returns {Array} 删除的元素
         */
        clearPlotElements: function () {
            var elements = this._plotLayer.elements;
            this._plotLayer.clear();
            this._tailedLayer.clear();
            this._plotOverlayTool.clear();
            // if (this.options.tailedLabelComponent)
            //     this.options.tailedLabelComponent.removeAll()
            //派发删除事件
            this._fireEvent(AppEvents.PLOT_DELETE, {
                elements: elements
            });
            return elements;
        },
        /**
         * 获取标绘方案字符串形式，用于标绘的存储
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param opts {Object} - 必填
         * @param opts.id {String} 可选，标绘方案的id，不传自动生成uuid
         * @param opts.name {String} - 可选，方案名称
         * @param opts.groupId {String} - 可选，方案分组
         * @param opts.elements {Array} 可选，需要保存的标绘元素数组，如果不传递，则默认保存标绘图层所有的标绘
         * @param opts.reserveId {Boolean} 可选，是否保留元素id不变，默认为false
         * @returns {String}
         */
        getPlotSchema: function (opts) {
            opts = opts || {};
            //随机生成方案id
            var schemaId = opts.id || CommonUtil.newUUID32();
            var schema = new PlotSchema({
                id: schemaId,
                name: opts.name || '',
                userId: opts.groupId
            });
            //
            var elements = [];
            if (CommonUtil.isArray(opts.elements)) {
                elements = opts.elements;
            } else {
                elements = this._plotLayer.elements;
            }
            for (var i = 0, len = elements.length; i < len; i++) {
                var ele = elements[i];
                //只保存未归属到其他标绘方案的标绘
                if (ele) {
                    var copy = ele.copy();
                    copy.unReset();
                    //是否保留id一致
                    if (opts.reserveId === true) {
                        copy.id = ele.id;
                    }
                    //
                    copy[PLOT_SCHEMA_KEY] = schemaId;

                    if (copy.kind == "tailedtext") {
                        const leadLabel = self.PlotComponent.getTailedLabelbyId(ele.id);
                        copy.tailedLabelAttr = self.PlotComponent.serializeTailedLabel(leadLabel);

                        // let tailedLabel = this.options.tailedLabelComponent._getTailedLabel(ele.id);
                        // tailedLabel._id = copy.id
                        // tailedLabel.options.id = copy.id
                        // copy.tailedLabelAttr = tailedLabel.serialize();
                        // copy.tailLabel = tailLabel;
                    }
                    schema.addElement(copy);

                }
            }
            return JSON.stringify(schema);
        },
        parseSchema(opts) {
            let schema = null;
            if (CommonUtil.isString(opts.schema)) {
                try {
                    schema = PlotSchema.fromJson(opts.schema);
                } catch (e) {
                    throw (new Error('参数类型错误！'));
                }
            }
            return schema;
        },
        /**
         * 加载标绘方案，用于展示存储的标绘
         * @method
         * @memberOf G.plot.PlotComponent.prototype
         * @param opts {Object} - 必填
         * @param opts.flag {boolean} - 选填 如果传true 则不给element赋值 schemaId 如果没有或false 则赋值
         * @param opts.schema {String/g2.plot.PlotSchema} - 必填，标绘方案存储的字符串，对应于getPlotSchema获取的字符串
         */
        loadPlotSchema: function (opts) {
            var schema;
            opts = opts || {};
            if (CommonUtil.isString(opts.schema)) {
                try {
                    // var schemaObj = JSON.parse(opts.schema);
                    // var deserializer = new g2.core.Deserializer();
                    // schema = deserializer.createJsInstance(schemaObj);
                    schema = PlotSchema.fromJson(opts.schema);
                } catch (e) {
                    throw (new Error('参数类型错误！'));
                }
            } else {
                schema = opts.schema;
            }
            if (opts.id) {
                schema.id = opts.id;
            }
            let count = schema.getCount();
            for (var i = 0; i < count; ++i) {
                var element = schema.getElement(i);
                element.reset();
                //如果元素已包含在图层中
                if (this._plotLayer.contains(element.id)) {
                    continue;
                }
                if (!opts.flag) {
                    element.schemaId = schema.id;
                }
                if (element.kind == "tailedtext") {
                    this._loadTailedlabel(element);
                }else if (element.kind == "overlay") {
                    this._loadOverlay(element);
                    element.elements[0].geometry.spatialReference = this.map.getSrid();
                }
                /* else {
                 this._plotLayer.add(element);
                 } */
                // 二维存的VectorMarkerSymbol在三维加载不了，手动转成PictureMarkerSymbol
                if (element.kind === 'point' && element.elements[0].symbol.$type.indexOf('VectorMarkerSymbol') > -1) {
                    const oSymbol = element.elements[0].symbol;
                    const symbolObj = Object.assign({}, oSymbol);
                    delete symbolObj.$type;
                    symbolObj.width = oSymbol.width * oSymbol.scale;
                    symbolObj.height = oSymbol.height * oSymbol.scale;
                    const symbol = new g2.sfs.PictureMarkerSymbol(symbolObj);
                    element.elements[0].symbol = symbol;
                }
                if (element.kind === "polyline" && element.elements[0].geometry.paths[0].points.length < 1 ) {
                    console.log('无效polyline');
                } else {
                    this._plotLayer.add(element);
                }
               
                //保存schema的id到element
                element['_schemaId'] = schema.id;
            }
        },
        /**
         * 控制单个引线标注显隐
         * @param {*} id
         * @param {*} visible
         */
        toggleElement: function (id, visible) {
            var leadLabel = this.getTailedLabelbyId(id);
            var element = this._tailedLayer.leadLabelHash.get(leadLabel);
            this._tailedLayer.showElement(element, visible);
            this._plotOverlayTool.showElement(id, visible);
            /*             this.options.tailedLabelComponent._getTailedLabel(id).toggleVisible(visible);
             let pointLayer = this.options.tailedLabelComponent._layer;
             var pointEle = pointLayer.find(id);
             pointLayer.showElement(pointEle, visible); */
        },
        /**
         * 根据id获取引线标注（引线标注和plotlayer中绘制的点具有相同id）
         * @param {*} id
         */
        getTailedLabelbyId: function (id) {
            return this._getTailedLabelById(id);
        },
        /**
         * 序列化引线标注
         * @param {*} leadLabel
         */
        serializeTailedLabel: function (leadLabel) {
            let options = jQuery.extend(true, {}, leadLabel)
            return JSON.stringify(options);
        }
    });
    //外部定义
    PlotComponentExt3D.extend(component);
    return component;
});